import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { rdsapLookupCodes } from 'src/rdsap/config/rdsap-lookup-codes.config';
@Component({
  selector: 'app-shower-profile-details',
  templateUrl: './shower-profile-details.component.html'
})
  
export class ShowerProfileDetailsComponent {
  lookupCodes = rdsapLookupCodes;
  constructor(
    public activeModal: NgbActiveModal) { 
    
  }
  private _bsHeating: any = {
    showerOutletType: 0,
    showerWWHRS: 1
  };
  isEdit: boolean;
  get bsHeating(): any {
    return this._bsHeating;
  }

  set eeHeating(value: any) {
    this._bsHeating = {
      ...value,
      showerOutletType: value.showerOutletType ?? 0,
      showerWWHRS: value.showerWWHRS ?? 1,
    };
  }

  filterLookupCodes(filter) {
    return this.lookupCodes.filter(x => x.dataItem === filter);
  }

  addNew(): void { 
    this._bsHeating.push({
      showerOutletType: 0,
      showerWWHRS: 1,
    })

  }

  close() {
    this.activeModal.close();
  }
  
}
